/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientUserEditOverlay{height:100%}.overlay.clientUserEditOverlay .ol-main{background:#f5f5f5}.overlay.clientUserEditOverlay .ol-main .ol-content{padding:0}.overlay.clientUserEditOverlay .ol-main .ol-content .content{padding-bottom:50px}@media screen and (max-width:360px){.overlay.clientUserEditOverlay .ol-main .ol-content .switch-state{font-size:14px}}"];
export { styles as styles };
